import api from "../services/api-service";

class QuizConfigPracticeService {
  create(body) {
    try {
      return api.post({
        url: "masked-configurations/create-masked-configuration",
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }

  getAll(search, page, limit) {
    try {
      return api.get({
        url: "masked-configurations/get-all-masked-configurations",
        params: {
          search,
          page,
          limit
        },
      });
    } catch (error) {
      return new Error(error);
    }
  }

  update(id, body) {
    try {
      return api.put({
        url: `masked-configurations/update-masked-configuration/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }

  delete(id) {
    try {
      return api.delete({
        url: `masked-configurations/delete-masked-configuration/${id}`,
      });
    } catch (error) {
      return new Error(error);
    }
  }

  findOne(id) {
    try {
      return api.get({
        url: `masked-configurations/get-masked-configuration/${id}?is_count_needed=true`,
      });
    } catch (error) {
      return new Error(error);
    }
  }
}

export default new QuizConfigPracticeService();
